
import DashboardError from '../pages/dashboard/_'
import DashboardPageWrapper from '../components/dashboard/DashboardPageWrapper'

export default {
  name: 'LayoutError',
  components: { DashboardPageWrapper, DashboardError },
  layout: 'default',
  props: {
    error: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      useCustomPage: false
    }
  },
  created () {
    if (this.$isOBS) {
      this.useCustomPage = true
      this.$nuxt.setLayout('none')
    } else if (this.$auth.loggedIn) {
      this.$nuxt.setLayout('dashboard')
    }
  },
  mounted () {
    this.$sentry.captureException(this.error)
  }
}
